
import React from 'react';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../common/components/form/form.module';

export const PickupPointBasicInfoComponent = ({ onInnerFormChange, selectedPickupPoint, stores }: any) => (
          <>
            <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'> 
        <InputContainer
              label="Store Name"
              labelField="StoreName"
              list={stores}
              onValueChange={(event: any, newValue: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PickupPointInfo.StoreId',
                  selectedPickupPoint?.PickupPointInfo
                );
              }}
              optionName='Choose Store'
              type="select"
              value={selectedPickupPoint?.PickupPointInfo?.StoreId}
              valueField="Id"
          />
      <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any, newValue: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PickupPointInfo.Name',
                  selectedPickupPoint?.PickupPointInfo
                );
              }}
              type="text"
              value={selectedPickupPoint?.PickupPointInfo?.Name}
          />
     
     <InputContainer
              label="Pickup Fee"
              name="PickupFee"
              onValueChange={(event: any, newValue: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PickupPointInfo.PickupFee',
                  selectedPickupPoint?.PickupPointInfo
                );
              }}
              type="number"
              value={selectedPickupPoint?.PickupPointInfo?.PickupFee}
          />
    <InputContainer
              label="Display Order"
              name="DisplayOrder"
              onValueChange={(event: any, newValue: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PickupPointInfo.DisplayOrder',
                  selectedPickupPoint?.PickupPointInfo
                );
              }}
              type="number"
              value={selectedPickupPoint?.PickupPointInfo?.DisplayOrder}
          />
          <div className='col-span-full'>
          <InputContainer
              label="Description"
              name="Description"
              onValueChange={(event: any, newValue: any) => {
                onInnerFormChange(
                  event.target.value,
                  'PickupPointInfo.Description',
                  selectedPickupPoint?.PickupPointInfo
                );
              }}
              type="text"
              value={selectedPickupPoint?.PickupPointInfo?.Description}
          />
          </div>
           
     </div>
}
expandedPanel="basicInfo"
headerTitle="Basic Info"
/>
</>
)
export default PickupPointBasicInfoComponent;
